import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconAttribute(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 7V5H7C7.55228 5 8 4.55228 8 4C8 3.44772 7.55228 3 7 3H4C3.44772 3 3 3.44772 3 4V7C3 7.55229 3.44772 8 4 8C4.55228 8 5 7.55229 5 7Z"
        fill="currentColor"
      />
      <path
        d="M3 17V20C3 20.5523 3.44772 21 4 21H7C7.55229 21 8 20.5523 8 20C8 19.4477 7.55229 19 7 19H5V17C5 16.4477 4.55228 16 4 16C3.44772 16 3 16.4477 3 17Z"
        fill="currentColor"
      />
      <path
        d="M17 5C16.4477 5 16 4.55228 16 4C16 3.44772 16.4477 3 17 3H20C20.5523 3 21 3.44772 21 4V7C21 7.55228 20.5523 8 20 8C19.4477 8 19 7.55228 19 7V5H17Z"
        fill="currentColor"
      />
      <path
        d="M19 17V19H17C16.4477 19 16 19.4477 16 20C16 20.5523 16.4477 21 17 21H20C20.5523 21 21 20.5523 21 20V17C21 16.4477 20.5523 16 20 16C19.4477 16 19 16.4477 19 17Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 7C8.44772 7 8 7.44772 8 8V16C8 16.5523 8.44772 17 9 17C9.55228 17 10 16.5523 10 16V13H14V16C14 16.5523 14.4477 17 15 17C15.5523 17 16 16.5523 16 16V8C16 7.44772 15.5523 7 15 7H9ZM14 11H10V9H14V11Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
